<template>
  <div class="grid-main bg-purple ">
    <h2 style="float: left;">菜单管理</h2>
    <el-button type="primary" @click="dialogmenuAdd=true">新增菜单</el-button>
    <div class="table-box" >
      <el-table
        :data="getMenuList"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="sort"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="parentId"
          label="父级id"
          width="180">
        </el-table-column>
        <el-table-column
          prop="menuName"
          label="菜单名称"
        >
        </el-table-column>
        <el-table-column
          prop="ico"
          label="菜单ico"
          width="180">
        </el-table-column>
        <el-table-column
          prop="menuUrl"
          label="菜单URL"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openmenu(scope.row.id)">编辑</el-button>
            <el-button

              size="mini"
              type="danger"
              @click="openDelete(scope.row.id)">删除</el-button>

          </template>
        </el-table-column>

      </el-table>

    </div>



  <!--新增菜单-->

  <el-dialog  :visible.sync="dialogmenuAdd" :before-close="dialogmenuclose">
    <el-form ref="form"  label-width="150px">

      <el-form-item label="菜单类型：">
        <el-select v-model="menuAdds.menuType" placeholder="请选择菜单类型" style="float: left;">
          <el-option v-for="item in menulist"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="父级菜单：" v-if="menuAdds.menuType ==2">
        <el-select v-model="menuAdds.parentId" placeholder="请选择父级菜单" style="float: left;">
          <el-option
            v-for="item in getMenuList"
            :key="item.id"
            :label="item.menuName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="菜单名称：">
        <el-input v-model="menuAdds.menuName" type="text" placeholder="请输入菜单名称"></el-input>
      </el-form-item>

      <el-form-item label="菜单ico：">
        <el-input v-model="menuAdds.ico" type="text" placeholder="请输入菜单ico"></el-input>
        <span style="float: left; color: #DCDFE6;">添加elementico</span>
      </el-form-item>

      <el-form-item label="菜单URL：">
        <el-input v-model="menuAdds.menuUrl" type="text" placeholder="请输入菜单URL"></el-input>
        <span style="float: left; color: #DCDFE6;">如/home/meun/</span>
      </el-form-item>

      <el-form-item label="菜单权限：">
        <el-input v-model="menuAdds.permission" type="text" placeholder="请输入菜单权限"></el-input>
        <span style="float: left; color: #DCDFE6;">如home:meun</span>
      </el-form-item>

      <el-form-item label="菜单状态：">
        <el-radio v-model="menuAdds.menuStatus" :label="0"  style="float: left;" >正常</el-radio>
        <el-radio v-model="menuAdds.menuStatus" :label="1"  style="float: left;">关闭</el-radio>
      </el-form-item>

      <el-form-item label="排序：">
        <el-input v-model="menuAdds.sort" type="number" min = '0' placeholder="请输入排序"></el-input>
        <span style="float: left; color: #DCDFE6;">数字越小越靠前</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="menuAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>


	<!--编辑菜单-->
  <el-dialog :visible.sync="dialogupdatmenu" :before-close="dialogmenuclose">
    <el-form ref="form"  label-width="150px">

      <el-form-item label="菜单类型：">
        <el-select v-model="menuupdates.menuType" placeholder="请选择菜单类型" style="float: left;">
          <el-option v-for="item in menulist"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="父级菜单：" v-if="menuupdates.menuType ==2">
        <el-select v-model="menuupdates.parentId" placeholder="请选择父级菜单" style="float: left;">
          <el-option
            v-for="item in getMenuList"
            :key="item.id"
            :label="item.menuName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="菜单名称：">
        <el-input v-model="menuupdates.menuName" type="text" placeholder="请输入菜单名称"></el-input>
      </el-form-item>

      <el-form-item label="菜单ico：">
        <el-input v-model="menuupdates.ico" type="text" placeholder="请输入菜单ico"></el-input>
        <span style="float: left; color: #DCDFE6;">添加elementico</span>
      </el-form-item>

      <el-form-item label="菜单URL：">
        <el-input v-model="menuupdates.menuUrl" type="text" placeholder="请输入菜单URL"></el-input>
        <span style="float: left; color: #DCDFE6;">如/home/meun/</span>
      </el-form-item>

      <el-form-item label="菜单权限：">
        <el-input v-model="menuupdates.permission" type="text" placeholder="请输入菜单权限"></el-input>
        <span style="float: left; color: #DCDFE6;">如home:meun</span>
      </el-form-item>

      <el-form-item label="菜单状态：">
        <el-radio v-model="menuupdates.menuStatus" :label="0"  style="float: left;" >正常</el-radio>
        <el-radio v-model="menuupdates.menuStatus" :label="1"  style="float: left;">关闭</el-radio>
      </el-form-item>

      <el-form-item label="排序：">
        <el-input v-model="menuupdates.sort" type="number" min = '0' placeholder="请输入排序"></el-input>
        <span style="float: left; color: #DCDFE6;">数字越小越靠前</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="menuupdate()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Menus",
  data() {
    return {

      //菜单列表
          menulist:[
            {
              id:1,
              name:'一级菜单'
            },
            {
              id:2,
              name:'二级菜单'
            }
          ],
          getMenuList:[],
          //添加菜单
          menuAdds:{
            parentId:'',
            menuName:'',
            ico:'',
            menuStatus:0,
            permission:'',
            menuUrl:'',
            menuType:'',
            sort:'',
          },
          dialogmenuAdd:false,
          //修改菜单
          menuid:'',
          menuupdates:{
            parentId:'',
            menuName:'',
            ico:'',
            menuStatus:0,
            permission:'',
            menuUrl:'',
            menuType:'',
            sort:'',
          },
          dialogupdatmenu:false,
    }
  },
  beforeRouteEnter(to, from, next) {

    next((vm) => {

    });
  },
  created() {

  },
  mounted() {
    this.selectgetMenuList();

  },
  methods: {
    dialogmenuclose(){
      this.dialogupdatmenu=false;
      this.menuupdates={
        parentId:'',
          menuName:'',
          ico:'',
          menuStatus:0,
          permission:'',
          menuUrl:'',
          menuType:'',
          sort:'',
      },
      this.dialogmenuAdd=false;
      this. menuAdds={
        parentId:'',
          menuName:'',
          ico:'',
          menuStatus:0,
          permission:'',
          menuUrl:'',
          menuType:'',
          sort:'',
      };
    },
    //菜单列表
    selectgetMenuList(){
      let that = this;

      this.$axios.defaults.withCredentials=true;
      this.$axios
        .get('/api/menu/getMenuList')
        .then(function (res) {

          if(res.data.code==200){
            that.getMenuList = res.data.data;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    //新增菜单
    menuAdd(){
      let that = this;
      if (that.menuAdds.menuType == '') {
        that.$message.error('请选择菜单类型');
        return false;
      }
      if (that.menuAdds.menuName == '') {
        that.$message.error('请输入菜单名称');
        return false;
      }
      if (that.menuAdds.ico == '') {
        that.$message.error('请输入菜单ico');
        return false;
      }
      if (that.menuAdds.menuUrl == '') {
        that.$message.error('请输入菜单URL');
        return false;
      }
      if (that.menuAdds.permission == '') {
        that.$message.error('请输入菜单权限');
        return false;
      }
      if (that.menuAdds.sort == '') {
        that.$message.error('请输入排序');
        return false;
      }
      var menuAddsdata = {
        parentId:Number(that.menuAdds.parentId),
        menuName:that.menuAdds.menuName,
        ico:that.menuAdds.ico,
        menuStatus:Number(that.menuAdds.menuStatus),
        permission:that.menuAdds.permission,
        menuUrl:that.menuAdds.menuUrl,
        menuType:Number(that.menuAdds.menuType),
        sort:Number(that.menuAdds.sort),
      }
      this.$axios
        .post('/api/menu/menuAdd', menuAddsdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增菜单失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增菜单成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
     //回写菜单
    selectMenuById(){
      let that = this;
      let menuupdatesdata = {
        id:that.menuid,
      }
      this.$axios
        .post('/api/menu/selectMenuById', menuupdatesdata)
        .then(function (res) {

          if( res.data.data.parentId == 0){
            that.menuAdds.menuType = 1;
          }else{
            that.menuAdds.menuType = 2;
          }

          that.menuupdates.parentId = res.data.data.parentId;
          that.menuupdates.menuName= res.data.data.menuName;
          that.menuupdates.ico=res.data.data.ico;
          that.menuupdates.permission=res.data.data.permission;
          that.menuupdates.menuStatus=res.data.data.menuStatus;
          that.menuupdates.menuUrl=res.data.data.menuUrl;
          that.menuupdates.menuType=res.data.data.menuType;
          that.menuupdates.sort=res.data.data.sort;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    //编辑菜单弹框
    openmenu(menuid){
      this.menuid = menuid;

      this.selectMenuById();

      window.setTimeout(() => {
        this.dialogupdatmenu = true;
      },100);

    },
    //修改菜单
    menuupdate(){
      let that = this;
      if (that.menuupdates.menuType == '') {
        that.$message.error('请选择菜单类型');
        return false;
      }
      if (that.menuupdates.menuName == '') {
        that.$message.error('请输入菜单名称');
        return false;
      }
      if (that.menuupdates.ico == '') {
        that.$message.error('请输入菜单ico');
        return false;
      }
      if (that.menuupdates.menuUrl == '') {
        that.$message.error('请输入菜单URL');
        return false;
      }
      if (that.menuupdates.permission == '') {
        that.$message.error('请输入菜单权限');
        return false;
      }
      if (that.menuupdates.sort == '') {
        that.$message.error('请输入排序');
        return false;
      }
      let menuupdatesdata = {
        id:this.menuid,
        parentId:Number(that.menuupdates.parentId),
        menuName:that.menuupdates.menuName,
        ico:that.menuupdates.ico,
        permission:that.menuupdates.permission,
        menuStatus:Number(that.menuupdates.menuStatus),
        menuUrl:that.menuupdates.menuUrl,
        menuType:Number(that.menuupdates.menuType),
        sort:Number(that.menuupdates.sort),
      }
      this.$axios
        .post('/api/menu/update', menuupdatesdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改菜单失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改菜单成功',
              type: 'success'
            });

            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },

    openDelete(menuId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.menubatchDelete(menuId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

  //删除菜单
    menubatchDelete(menuId){
      let that = this;
      let menuIdsdata = {
        menusIds:[]
      }
      menuIdsdata.menusIds.push(menuId);
      this.$axios
        .post('/api/menu/batchDelete',menuIdsdata)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


  },
  watch: {},
}
</script>

<style>
.grid-main {
  border-radius: 0px;
  min-height: 36px;
  position: relative;
  margin-bottom: 20px;
  padding: 60px;
}
/deep/ .el-button--primary{
  width: auto!important;
  margin-bottom: 10px;
  margin-top: 0px!important;
  float: right;

}

.el-form-item__content {
  line-height: 15px;

}
.el-radio {

  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Menus.vue